import styled from 'styled-components';
import {colorPalette, defaultSize, viewSize} from '../../../config';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

export const ImgWrapper = styled.div`
	margin-bottom: 10.5rem;
`;

export const CardWrapper = styled.div`
	> img {
		margin-top: -80px;

		max-width: 100%;
		width: 100%;
		height: auto;
	}
	@media screen and (max-width: ${viewSize.tablet}) {
		flex-direction: column;
		align-items: center;
		> img {
			width: 100%;
			height: auto;
			margin-right: 0;
			margin-top: -100px;
			margin-bottom: 24px;
		}
	}
	@media screen and (max-width: ${viewSize.mobile}) {
	}
`;
